import { render, staticRenderFns } from "./MerchantCompanyPage.vue?vue&type=template&id=b58c8098"
import script from "./MerchantCompanyPage.vue?vue&type=script&lang=js"
export * from "./MerchantCompanyPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports